import { orgScopedApiClient } from 'api/orgScopedClient'
import { AsyncUpdate } from 'types'

import { CerebroPaginatedResponse, CerebroResourceResponse } from '../types'

export const getAsyncUpdates = (
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<AsyncUpdate>> =>
    orgScopedApiClient.get(`/api/async_updates/`, { params })

export const updateAsyncUpdate = (
    id: string,
    data: unknown
): Promise<CerebroResourceResponse<AsyncUpdate>> =>
    orgScopedApiClient.patch(`/api/async_updates/${id}/`, data)

export const getAsyncUpdateViaCsv = (
    params: Record<string, unknown>
): Promise<CerebroResourceResponse<{ url: string }>> =>
    orgScopedApiClient.get(`/api/async_update_via_csv/`, { params })

export const triggerAsyncUpdateViaCsv = (
    name: string,
    type: string,
    data: unknown
): Promise<CerebroResourceResponse<AsyncUpdate>> =>
    orgScopedApiClient.patch(
        `/api/async_update_via_csv/?name=${name}&type=${type}`,
        data
    )
